module.exports = __webpack_public_path__ + "static/media/mt.c93e3089.svg";